// extracted by mini-css-extract-plugin
export var actions = "_kf-d";
export var benefitCard = "_kf-a";
export var benefitIcon = "_kf-b";
export var benefitLabel = "_kf-c";
export var benefits = "_kf-9";
export var bodyText = "_kf-8";
export var closeButton = "_kf-2";
export var content = "_kf-3";
export var eyebrow = "_kf-4";
export var heading = "_kf-5";
export var image = "_kf-f";
export var imagePanel = "_kf-e";
export var modal = "_kf-0";
export var shell = "_kf-1";
export var title = "_kf-6";
export var titleOffer = "_kf-7";